import styled from 'styled-components'

export const TaskFormGroup = styled.div`
    width: 100%;
    display: grid;
    align-items: center;
    text-align: left;
`